import {PRINTER_GET_AVAILABLES_PRINTERS_SUCCESS, PRINTER_SET_PRINTER} from "../config/actions";

let defaultState = {
    availablePrinters: [],
    selectedPrinter: null
};

const printerReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PRINTER_GET_AVAILABLES_PRINTERS_SUCCESS: {
            const availablePrinters = action.availablePrinters || [];
            let selectedPrinter = null;

            if (state.selectedPrinter) {
                selectedPrinter = availablePrinters.find((el) => el.identifier === state.selectedPrinter.identifier);
            }

            if (!selectedPrinter && availablePrinters.length === 1) {
                selectedPrinter = availablePrinters[0];
            }

            return Object.assign({}, state, {
                availablePrinters: availablePrinters,
                selectedPrinter: selectedPrinter || null
            });
        }
        case PRINTER_SET_PRINTER:
            return Object.assign({}, state, {
                selectedPrinter: action.selectedPrinter
            });
        default:
            return state;
    }
};

export default printerReducer;
